import { animate } from 'motion/mini'

const part = (target, keyframes, duration, origin, delay = 0, times) => ({
  target,
  keyframes,
  origin,
  options: { duration, delay, ease: 'ease-in-out', ...(times ? { times } : {}) },
})

// Native Hugeicons geometry with the per-part choreography from hugeicons-animated.
const navigationIconMotions = {
  residentEdit: [
    part(
      2,
      { transform: ['translate(0,0)', 'translate(-1px,1px)', 'translate(0,0)'] },
      0.35,
      '17px 17px',
    ),
    part(0, { opacity: [1, 0.65, 1] }, 0.35, '10px 8px'),
  ],
  chargeCodeSearch: [
    part(
      3,
      { transform: ['translateX(0)', 'translateX(-1px)', 'translateX(0)'] },
      0.3,
      '15px 14px',
    ),
    part(0, { opacity: [1, 0.4, 1] }, 0.25, undefined, 0.05),
    part(1, { opacity: [1, 0.4, 1] }, 0.25, undefined, 0.1),
  ],
  receivePayment: [
    part(
      2,
      { transform: ['translate(0, 0)', 'translate(-1.5px, 1.5px)', 'translate(0, 0)'] },
      0.45,
      '19px 5px',
    ),
    part(0, { opacity: [1, 0.55, 1] }, 0.4, '12px 12px', 0.1),
  ],
  clock: [part(1, { transform: ['rotate(0)', 'rotate(360deg)'] }, 0.72, '12px 12px')],
  building: [
    part(4, { transform: ['scaleY(1)', 'scaleY(.94)', 'scaleY(1)'] }, 0.35, '9.5px 22px'),
    part(1, { opacity: [1, 0.3, 1] }, 0.35, '9.5px 11px', 0.08),
    part(2, { transform: ['scaleX(1)', 'scaleX(.65)', 'scaleX(1)'] }, 0.35, '9.5px 19.5px', 0.12),
  ],
  robot: [
    part(0, { rotate: [0, -15, 12, -5, 0] }, 0.8, '12px 4px'),
    part(
      2,
      {
        transform: ['scaleY(1)', 'scaleY(.1)', 'scaleY(1)', 'scaleY(1)', 'scaleY(.1)', 'scaleY(1)'],
      },
      0.9,
      '9.25px 8.25px',
    ),
    part(
      3,
      {
        transform: ['scaleY(1)', 'scaleY(.1)', 'scaleY(1)', 'scaleY(1)', 'scaleY(.1)', 'scaleY(1)'],
      },
      0.9,
      '14.75px 8.25px',
      0.03,
    ),
    part(
      4,
      {
        transform: [
          'rotate(0) translateY(0)',
          'rotate(-5deg) translateY(-.6px)',
          'rotate(4deg) translateY(0)',
          'rotate(0) translateY(0)',
        ],
      },
      1,
      '12px 9px',
    ),
  ],
  circleCheck: [
    part(0, { scale: [1, 0.96, 1.025, 1] }, 0.48, '12px 12px', 0.34),
    part(1, { scale: [1, 0.12, 0, 0.25, 1] }, 0.82, '12px 12px'),
  ],
  sliders: [
    part(
      2,
      { transform: ['translateX(0)', 'translateX(-2.8px)', 'translateX(.45px)', 'translateX(0)'] },
      0.48,
      '16px 12px',
    ),
    part(
      3,
      { transform: ['translateX(0)', 'translateX(3px)', 'translateX(-.45px)', 'translateX(0)'] },
      0.48,
      '10px 5px',
      0.07,
    ),
    part(
      4,
      { transform: ['translateX(0)', 'translateX(-2.4px)', 'translateX(.4px)', 'translateX(0)'] },
      0.48,
      '12px 19px',
      0.14,
    ),
  ],
  grid: [
    ...[0, 1, 2, 3].map((target) =>
      part(
        target,
        {
          transform: [
            'scale(1) rotate(0)',
            'scale(.72) rotate(-5deg)',
            'scale(1.1) rotate(2deg)',
            'scale(1) rotate(0)',
          ],
        },
        0.46,
        `${target % 2 === 0 ? 6.5 : 17.5}px ${target < 2 ? 6.5 : 17.5}px`,
        target * 0.055,
      ),
    ),
  ],
  message: [
    part(1, { scale: [1, 0.62, 1.12, 1] }, 0.68, '10% 97%', 0, [0, 0.28, 0.72, 1]),
    part(
      0,
      { transform: ['scaleX(1)', 'scaleX(.18)', 'scaleX(1.12)', 'scaleX(1)'] },
      0.58,
      '8.5px 12px',
      0.18,
      [0, 0.25, 0.72, 1],
    ),
  ],
  download: [
    part(
      1,
      {
        transform: ['translateY(0)', 'translateY(5px)', 'translateY(-5px)', 'translateY(0)'],
        opacity: [1, 0, 0, 1],
      },
      0.7,
      undefined,
      0,
      [0, 0.42, 0.5, 1],
    ),
    part(
      0,
      { transform: ['translateY(0)', 'translateY(1.2px)', 'translateY(0)'] },
      0.3,
      undefined,
      0.32,
    ),
  ],
  link: [
    part(
      0,
      {
        transform: [
          'translate(0,0) rotate(0)',
          'translate(-2.4px,2.4px) rotate(-7deg)',
          'translate(.45px,-.45px) rotate(2deg)',
          'translate(0,0) rotate(0)',
        ],
      },
      0.72,
      '10px 15px',
      0,
      [0, 0.32, 0.72, 1],
    ),
    part(
      1,
      {
        transform: [
          'translate(0,0) rotate(0)',
          'translate(2.4px,-2.4px) rotate(7deg)',
          'translate(-.45px,.45px) rotate(-2deg)',
          'translate(0,0) rotate(0)',
        ],
      },
      0.72,
      '14px 9px',
      0,
      [0, 0.32, 0.72, 1],
    ),
  ],
  users: [
    part(
      0,
      {
        transform: [
          'translateY(0) scale(1)',
          'translateY(-2.3px) scale(1.13)',
          'translateY(.4px) scale(.97)',
          'translateY(0) scale(1)',
        ],
      },
      0.72,
      '12px 11px',
      0,
      [0, 0.38, 0.72, 1],
    ),
    part(
      4,
      { transform: ['scaleX(1)', 'scaleX(.68)', 'scaleX(1.12)', 'scaleX(1)'] },
      0.68,
      '12px 19.5px',
      0.08,
      [0, 0.32, 0.72, 1],
    ),
    ...[1, 3].map((target) =>
      part(
        target,
        {
          transform: ['translateX(0)', 'translateX(2.5px)', 'translateX(-.45px)', 'translateX(0)'],
        },
        0.7,
        undefined,
        0.04,
        [0, 0.35, 0.72, 1],
      ),
    ),
    ...[2, 5].map((target) =>
      part(
        target,
        {
          transform: ['translateX(0)', 'translateX(-2.5px)', 'translateX(.45px)', 'translateX(0)'],
        },
        0.7,
        undefined,
        0.04,
        [0, 0.35, 0.72, 1],
      ),
    ),
  ],
  database: [
    part(
      0,
      {
        transform: [
          'scaleX(1) translateY(0)',
          'scaleX(.92) translateY(-.5px)',
          'scaleX(1.04) translateY(0)',
          'scaleX(1) translateY(0)',
        ],
      },
      0.5,
      '12px 5px',
    ),
    part(2, { transform: ['scaleX(.55)', 'scaleX(1.08)', 'scaleX(1)'] }, 0.52, '4px 12px', 0.12),
    part(4, { transform: ['scaleX(.55)', 'scaleX(1.08)', 'scaleX(1)'] }, 0.52, '4px 19px', 0.26),
    part(
      1,
      { transform: ['translateX(0)', 'translateX(1.2px)', 'translateX(0)'] },
      0.38,
      undefined,
      0.08,
    ),
    part(
      3,
      { transform: ['translateX(0)', 'translateX(1.2px)', 'translateX(0)'] },
      0.38,
      undefined,
      0.22,
    ),
  ],
  puzzle: [
    part(
      'svg',
      {
        transform: [
          'translate(0,0) rotate(0) scale(1)',
          'translate(1.65px,-1.9px) rotate(10deg) scale(.98)',
          'translate(.35px,-.3px) rotate(1.5deg) scale(1.01)',
          'translate(-.16px,.22px) rotate(-.8deg) scale(.985)',
          'translate(0,0) rotate(0) scale(1)',
        ],
      },
      0.78,
      '12px 12px',
    ),
  ],
  dashboard: [
    ...[
      [3, '6.75px 6.75px', 0],
      [1, '17.25px 6.75px', 0.06],
      [2, '6.75px 17.25px', 0.12],
      [0, '17.25px 17.25px', 0.18],
    ].map(([target, origin, delay]) =>
      part(
        target,
        {
          transform: [
            'translateY(0) scale(1)',
            'translateY(1.4px) scale(.74)',
            'translateY(-.4px) scale(1.1)',
            'translateY(0) scale(1)',
          ],
        },
        0.48,
        origin,
        delay,
        [0, 0.18, 0.65, 1],
      ),
    ),
  ],
  wallet: [
    part(
      0,
      {
        transform: [
          'translateY(0)',
          'translateY(-3.8px)',
          'translateY(-3.8px)',
          'translateY(.25px)',
          'translateY(0)',
        ],
      },
      0.68,
      '12px 7px',
      0,
      [0, 0.34, 0.56, 0.84, 1],
    ),
    part(
      1,
      { transform: ['scaleX(1)', 'scaleX(.98)', 'scaleX(1.01)', 'scaleX(1)'] },
      0.56,
      '12px 14px',
    ),
    part(
      2,
      { transform: ['scaleX(1)', 'scaleX(.34)', 'scaleX(1.08)', 'scaleX(1)'] },
      0.52,
      '21px 14px',
      0.06,
    ),
  ],
  invoice: [
    part(4, { scale: [1, 0.82, 1.12, 1] }, 0.52, '12.5px 13.5px'),
    part(
      2,
      { transform: ['scaleX(1)', 'scaleX(.45)', 'scaleX(1.08)', 'scaleX(1)'] },
      0.5,
      '6px 6px',
      0.08,
    ),
    part(
      3,
      { transform: ['translateX(0)', 'translateX(2px)', 'translateX(0)'] },
      0.4,
      undefined,
      0.16,
    ),
  ],
  eye: [
    part(
      2,
      {
        transform: [
          'translateX(0) scaleY(1)',
          'translateX(-1.6px) scaleY(1)',
          'translateX(1.5px) scaleY(1)',
          'translateX(0) scaleY(.12)',
          'translateX(0) scaleY(1)',
        ],
      },
      0.88,
      '12px 14px',
    ),
    part(
      1,
      { transform: ['scaleY(1)', 'scaleY(1)', 'scaleY(1)', 'scaleY(.18)', 'scaleY(1)'] },
      0.88,
      '12px 14px',
    ),
    part(
      0,
      {
        transform: [
          'translateY(0)',
          'translateY(0)',
          'translateY(0)',
          'translateY(.65px)',
          'translateY(0)',
        ],
      },
      0.88,
      '12px 8px',
    ),
  ],
  clipboard: [
    ...[0, 1].map((target) =>
      part(
        target,
        {
          transform: [
            'translate(0,0) rotate(0)',
            'translate(.35px,-.25px) rotate(1.5deg)',
            'translate(-5px,3px) rotate(-30deg)',
            'translate(-5px,3px) rotate(-30deg)',
            'translate(.45px,-.3px) rotate(1deg)',
            'translate(0,0) rotate(0)',
          ],
        },
        0.9,
        '14.5px 10.5px',
      ),
    ),
  ],
  // ClipboardCheckIcon orders its paths [checkmark, clip, board], so the
  // `clipboard` recipe above would swing the checkmark off a stationary board.
  clipboardCheck: [
    part(
      1,
      { transform: ['translateY(0)', 'translateY(-1px)', 'translateY(.2px)', 'translateY(0)'] },
      0.62,
      '12px 3.5px',
    ),
    part(0, { scale: [1, 0.72, 1.12, 1] }, 0.52, '12px 13.5px', 0.12),
  ],
  user: [
    part(0, { rotate: [0, 16, -4, 0] }, 0.6, '12px 13.5px'),
    part(
      1,
      { transform: ['translateY(0)', 'translateY(0)', 'translateY(.6px)', 'translateY(0)'] },
      0.5,
      undefined,
      0.3,
    ),
  ],
  mail: [
    part(
      1,
      {
        transform: [
          'translateY(0) scaleY(1)',
          'translateY(-2px) scaleY(.12)',
          'translateY(-3px) scaleY(-.72)',
          'translateY(0) scaleY(1)',
        ],
      },
      0.94,
      '12px 8px',
    ),
    part(
      0,
      {
        transform: [
          'scale(1)',
          'scaleX(1.035) scaleY(.958)',
          'scaleX(.985) scaleY(1.022)',
          'scale(1)',
        ],
      },
      0.94,
      '12px 14px',
    ),
  ],
  userCheck: [
    part(
      0,
      { transform: ['translateY(0)', 'translateY(-1.1px)', 'translateY(.45px)', 'translateY(0)'] },
      0.5,
      '10px 8px',
    ),
    part(
      1,
      { transform: ['translateY(0)', 'translateY(-1.1px)', 'translateY(.45px)', 'translateY(0)'] },
      0.5,
      '10px 18px',
    ),
    part(2, { scale: [0.72, 1.13, 0.97, 1] }, 0.5, '18px 17px', 0.08),
  ],
  clipboardPaste: [
    ...[0, 1].map((target) =>
      part(
        target,
        {
          transform: [
            'translateX(0) scaleX(1)',
            'translateX(-1.4px) scaleX(.9)',
            'translateX(-1.4px) scaleX(.9)',
            'translateX(1.6px) scaleX(1.04)',
            'translateX(-.35px) scaleX(.99)',
            'translateX(0) scaleX(1)',
          ],
        },
        0.68,
        '15px 13px',
      ),
    ),
    ...[2, 3].map((target) =>
      part(
        target,
        {
          transform: [
            'translateX(0) scale(1)',
            'translateX(0) scale(1)',
            'translateX(0) scale(1)',
            'translateX(-.5px) scale(.985)',
            'translateX(.22px) scale(1.012)',
            'translateX(0) scale(1)',
          ],
        },
        0.68,
        '10px 12px',
      ),
    ),
  ],
  rocket: [
    part(
      'svg',
      {
        transform: [
          'translate(0,0) rotate(0)',
          'translate(-4%,4%) rotate(1.5deg)',
          'translate(85%,-85%) rotate(-5deg)',
          'translate(-65%,65%) rotate(-5deg)',
          'translate(0,0) rotate(0)',
        ],
      },
      0.94,
      '12px 12px',
    ),
    ...[2, 3, 4].map((target, index) =>
      part(
        target,
        {
          transform: [
            'translate(0,0)',
            `translate(${-index - 1}px,${index + 1}px)`,
            'translate(0,0)',
          ],
          opacity: [1, 0.2, 1],
        },
        0.64,
        undefined,
        index * 0.018,
      ),
    ),
  ],
  settings: [part(0, { rotate: [0, 202, 177.5, 180] }, 0.92, '12px 12px', 0, [0, 0.72, 0.9, 1])],
  help: [
    part(0, { scale: [1, 0.98, 1.018, 0.996, 1] }, 0.62, '12px 12px'),
    part(
      1,
      {
        transform: [
          'rotate(0) translateY(0)',
          'rotate(-10deg) translateY(-.2px)',
          'rotate(7deg) translateY(.1px)',
          'rotate(-2deg) translateY(0)',
          'rotate(0) translateY(0)',
        ],
      },
      0.62,
      '12px 16.75px',
    ),
    part(2, { scale: [1, 0.88, 1.16, 0.94, 1] }, 0.62, '12px 16.75px'),
  ],
  notification: [
    part('svg', { rotate: [0, -14, 11, -8, 5, -2, 0] }, 0.9, '50% 0%'),
    part(
      2,
      {
        transform: [
          'translateX(0)',
          'translateX(2.2px)',
          'translateX(-1.8px)',
          'translateX(1.2px)',
          'translateX(-.7px)',
          'translateX(.3px)',
          'translateX(0)',
        ],
      },
      0.9,
    ),
  ],
  search: [
    part(
      'svg',
      {
        transform: [
          'translate(0,0) rotate(0) scale(1)',
          'translate(1.25px,-.55px) rotate(14deg) scale(.78)',
          'translate(.4px,-.8px) rotate(6deg) scale(.76)',
          'translate(-.65px,.25px) rotate(-8deg) scale(.8)',
          'translate(-.15px,.1px) rotate(-2.5deg) scale(1.08)',
          'translate(0,0) rotate(0) scale(1)',
        ],
      },
      1.24,
      '11px 11px',
    ),
  ],
  file: [
    part(
      0,
      {
        transform: [
          'translateY(0) rotate(0)',
          'translateY(-.8px) rotate(-1deg)',
          'translateY(.45px) rotate(.5deg)',
          'translateY(0) rotate(0)',
        ],
      },
      0.58,
      '12px 12px',
    ),
    part(
      1,
      { transform: ['scaleX(1)', 'scaleX(.5)', 'scaleX(1.1)', 'scaleX(1)'] },
      0.48,
      '8px 7px',
      0.12,
    ),
    part(
      2,
      { transform: ['scaleX(1)', 'scaleX(.5)', 'scaleX(1.1)', 'scaleX(1)'] },
      0.48,
      '8px 11px',
      0.12,
    ),
  ],
  refresh: [part('svg', { rotate: [0, -25, 360] }, 0.9, '12px 12px', 0, [0, 0.2, 1])],
  mic: [
    part(
      0,
      { transform: ['scaleY(1)', 'scaleY(.96)', 'scaleY(1.04)', 'scaleY(1)'] },
      0.76,
      '12px 16px',
    ),
    part(
      1,
      { transform: ['scaleX(1)', 'scaleX(.3)', 'scaleX(1)', 'scaleX(.55)', 'scaleX(1)'] },
      1.1,
      '17px 9px',
    ),
    part(
      2,
      { transform: ['translateY(0)', 'translateY(1px)', 'translateY(-.4px)', 'translateY(0)'] },
      0.76,
      '12px 18px',
      0.08,
    ),
  ],
  chartLine: [
    part(0, { transform: ['scale(1)', 'scale(.94)', 'scale(1)'] }, 0.5, '3px 21px'),
    part(
      1,
      {
        transform: [
          'translateY(0)',
          'translateY(1.6px) scaleY(.85)',
          'translateY(-.6px) scaleY(1.05)',
          'translateY(0)',
        ],
      },
      0.7,
      '13px 20px',
      0.05,
      [0, 0.3, 0.7, 1],
    ),
  ],
  collapse: [
    part(
      'svg',
      {
        transform: [
          'translateX(0) scaleX(1)',
          'translateX(-3px) scaleX(.72)',
          'translateX(1px) scaleX(1.14)',
          'translateX(0) scaleX(1)',
        ],
      },
      0.62,
      '8px 8px',
      0,
      [0, 0.32, 0.72, 1],
    ),
  ],
  theme: [
    part(
      'svg',
      {
        transform: [
          'rotate(0) scale(1)',
          'rotate(-40deg) scale(.62)',
          'rotate(195deg) scale(1.14)',
          'rotate(180deg) scale(1)',
          'rotate(0) scale(1)',
        ],
      },
      0.86,
      '10px 10px',
      0,
      [0, 0.2, 0.62, 0.8, 1],
    ),
  ],
  logout: [
    part(
      'svg',
      {
        transform: [
          'translateX(0) scaleX(1)',
          'translateX(-2px) scaleX(.82)',
          'translateX(4px) scaleX(1.08)',
          'translateX(-.5px) scaleX(.98)',
          'translateX(0) scaleX(1)',
        ],
        opacity: [1, 1, 0.28, 1, 1],
      },
      0.76,
      '10px 10px',
      0,
      [0, 0.22, 0.52, 0.8, 1],
    ),
  ],
}

const getNavigationIcon = (event) => event.currentTarget.querySelector('svg')
const shouldReduceNavigationMotion = () =>
  globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches

const startNavigationIconMotion = (event, motionName) => {
  if (shouldReduceNavigationMotion()) return

  const icon = getNavigationIcon(event)
  const recipe = navigationIconMotions[motionName]
  if (!icon || !recipe) return

  recipe.forEach(({ target, keyframes, origin, options }) => {
    const element = target === 'svg' ? icon : icon.children.item(target)
    if (!element) {
      if (import.meta.env.DEV) {
        console.warn(`Missing Hugeicons child ${target} for navigation motion ${motionName}`)
      }
      return
    }
    if (origin) {
      element.style.transformBox = 'view-box'
      element.style.transformOrigin = origin
    }
    animate(element, keyframes, options)
  })
}

export const getNavigationIconMotionHandlers = (motionName) => ({
  onMouseEnter: (event) => startNavigationIconMotion(event, motionName),
  onFocus: (event) => startNavigationIconMotion(event, motionName),
})
